import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listPeritos:[],
  listPartidos:[],
  listStats:[],
  // listEspecialidades:[],
  newPerito:[],
  peritoSelected:[],
  currentSolicitud:[],
  listRefrendos:[],
  listPeritosInformes:[]
};
export const mutations = {
  GET_FILES({ context }, data) {
    state.resultFile = Object.assign({}, data);
  },
  GET_PERITOS({ context }, peritos) {
    state.listPeritos = Object.assign({}, peritos);
  },
  GET_STATS({ context }, stats) {
    state.listStats = Object.assign({}, stats);
  },
  GET_PARTIDOS({ context }, result_partidos) {
    if (result_partidos) {
      let partidos = [];
      Object.entries(result_partidos.data.data.partidos_judiciales).forEach(([key, val]) => partidos.push(val));
      return (state.listPartidos = partidos);
    }
  },
  GET_ESPECIALIDAD({ context }, especialidades) {
    state.listEspecialidades = Object.assign({}, especialidades);
  },
  SAVE_PERITO({ context }, perito) {
    state.newPerito = Object.assign({}, perito);
  },
  EDIT_PERITO({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
  PERITO_SELECTED({ context }, perito) {
    state.peritoSelected = Object.assign({}, perito);
  },
  SOLICITUD_SELECTED({ context }, solicitud) {
    state.currentSolicitud = Object.assign({}, solicitud);
  },
  GET_REFRENDADOS_LIST({ context }, refrendos) {
    if (refrendos) {
      let refrendos_array = [];
      Object.entries(refrendos).forEach(([key, val]) => refrendos_array.push(val));
      return (state.listRefrendos = refrendos_array);
    }
  },
  GET_PERITOS_INFORMES({ context }, informes) {
    if (informes) {
      let informes_array = [];
      Object.entries(informes).forEach(([key, val]) => informes_array.push(val));
      return (state.listPeritosInformes = informes_array);
    }
  },
};
export const actions = {

  SHOW_PERITO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // commit("SET_LOADING", false);
          commit("PERITO_SELECTED", response.data.data.perito);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SHOW_SOLICITUD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // commit("SET_LOADING", false);
          commit("SOLICITUD_SELECTED", response.data.data.solicitud);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_ENTREGAR_SOLICITUD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("PERITO_SELECTED", response.data.data.perito);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_PERITOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_PERITOS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_STATS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_STATS", response.data.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_REFRENDO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_REFRENDO", response.data.data);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_PARTIDOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_PARTIDOS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_REGIONES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_REGIONES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_DISTRITOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_DISTRITOS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_PERITO({ commit }, perito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(perito)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_PERITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_PERITO({ commit }, dataUser) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_PERITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  ACTIVAR_PERITO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("ACTIVAR_PERITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_PERITO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_SOLICITUDES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_REFRENDADOS_LIST({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_REFRENDADOS_LIST", response.data.data.refrendos.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_PERITOS_INFORMES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_PERITOS_INFORMES", response.data.data.peritos.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_PERITO_EXTEMPORANEO({ commit }, data) { //axios, mandar parametros para post
    console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_PERITO_EXTEMPORANEO", response.data.data.perito);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_PERITO_EXTEMPORANEO({ commit }, data) { //axios, mandar parametros para post
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_PERITO_EXTEMPORANEO", response.data.data.perito);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {//leer datos
  listPeritos: state => state.listPeritos,
  listPartidos: state => state.listPartidos,
  listStats: state => state.listStats,
  newPerito: state => state.newPerito,
  peritoSelected: state => state.peritoSelected,
  currentSolicitud: state => state.currentSolicitud,
  listRefrendos: state => state.listRefrendos,
  listPeritosInformes: state => state.listPeritosInformes
};
